<template>
  <top :topindex="1"></top>

  <!-- banner -->
  <div class="banner">
    <div class="swiper-container" id="banner">
      <div class="swiper-wrapper" v-if="bannerList.length > 0">
        <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
          <a v-if="item.linkUrl == null || item.linkUrl == ''">
            <figure class="web" :title="item.title"
              :style="'background-image:url(\'' + $bindImg(item.coverImage) + '\')'"></figure>
            <figure class="wap" :title="item.title"
              :style="'background-image:url(\'' + $bindImg(item.phoneImage) + '\')'"></figure>
          </a>
          <a v-else :href="item.linkUrl" target="_blank">
            <figure class="web" :title="item.title"
              :style="'background-image:url(\'' + $bindImg(item.coverImage) + '\')'"></figure>
            <figure class="wap" :title="item.title"
              :style="'background-image:url(\'' + $bindImg(item.phoneImage) + '\')'"></figure>
          </a>
        </div>
      </div>

      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>

    <!-- 热点关注 -->
    <div class="focusList wow fadeInUp">
      <div class="titBox">
        <h5><span>热点</span>关注</h5>
        <a href="javascript:;" class="more" @click="$pushTo(`/BeforeExam/focusList`)">更多</a>
      </div>
      <ul>
        <li v-for="item in rdgzList" :key="item.id">
          <a href="javascrpt:;" @click="$pushTo(`/BeforeExam/focusDeta?id=${item.id}`)" class="dot">
            <span class="type">[{{ item.label }}]</span>{{ item.title }}
          </a>
        </li>
      </ul>
    </div>
    <!-- 热点关注 -->
  </div>

  <!-- banner -->

  <!-- advert -->
  <div class="advertFoor">
    <div class="w1600">
      <ul class="discList wow fadeInUp">
        <li v-for="item in saleBannerList" :key="item.id">
          <a :href="item.linkUrl" target="_blank"><img :src="bindImg(item.coverImage)" alt="" /></a>
        </li>
      </ul>
      <ul class="cursList wow fadeInUp">
        <li v-for="item in recommendedCourses1" :key="item.id" class="clearfix">
          <div class="txtBox">
            <span class="type">{{ item.classsizeTitle }}</span>
            <h5 class="dot2">{{ item.title }}</h5>
            <p>{{ item.classHour }}学时 / {{ item.lecturerTitle }}</p>
          </div>
          <a @click="$pushTo(`/BeforeExam/curriculumInfo?id=${item.id}`)" class="audBtn">我要试听</a>
        </li>
      </ul>
    </div>
  </div>
  <!-- advert -->

  <!-- Foor1 -->
  <div class="idxFoor1">
    <div class="Hometit wow fadeInUp">
      <div class="w1600">
        <h3>课程班级</h3>
        <p>课程内容权威可靠，业内知名老师授课，随时随地随心学习</p>
      </div>
      <a href="javascript:;" @click="$onlineconSultation()" class="sultBtn" title="我要咨询"></a>
    </div>
    <div class="w1600">
      <div class="deliverBtn wow fadeInUp">
        <h5>买课领取更多免费资料！</h5>
        <a href="javascript:;" @click="$onlineconSultation()" class="seekBtn">咨询客服</a>
      </div>
      <div class="classList">
        <div class="item wow fadeInUp" v-for="item in category" :key="item.id" @click="jump(item.id)"
          style="cursor: pointer;">
          <h3>{{ item.title }}</h3>
          <ul>
            <li v-for="categoryItem in item.contentCategoryList" v-show="categoryItem.contentList.length > 0"
              :key="categoryItem.id">
              <h5>{{ categoryItem.title }}：</h5>
              <div class="des" v-for="contentItem in categoryItem.contentList" :key="contentItem.id">
                <div class="flBox" v-if="categoryItem.id == 4 || categoryItem.id == 3">
                  <div class="iB" v-for="(content, index) in Math.ceil(contentItem.remark.split(';').length / 3)"
                    :key="index">
                    <p v-for="(data, ItemI) in contentItem.remark.split(';').slice(index * 3, content * 3)" :key="ItemI"
                      v-show="data.length > 0">
                      {{ categoryItem.id == 3 ? index * 3 + ItemI + 1 + "." : "" }}{{ data }}
                    </p>
                  </div>
                </div>
                <p v-else v-for="(content, idx) in contentItem.remark.split(';')" :key="idx">
                  {{ content }}
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="courseTab wow fadeInUp">
        <table cellpadding="0" cellspacing="0">
          <tr>
            <th>课程名称</th>
            <th>课时</th>
            <th>科目</th>
            <th>费用</th>
            <th>试听</th>
            <th>咨询</th>
            <th>购买</th>
          </tr>
          <tr v-for="item in recommendedCourses" :key="item.id">
            <td>
              <p>{{ item.title }}</p>
            </td>
            <td>
              <p>{{ item.classHour }}</p>
            </td>
            <td>
              <p>{{ item.subjectTitle }}</p>
            </td>
            <td>
              <p class="price">￥{{ item.price }}</p>
            </td>
            <td>
              <a href="javascript:;" @click="$pushTo(`/BeforeExam/curriculumInfo?id=${item.id}`)"
                class="audBtn">立即试听</a>
            </td>
            <td>
              <a href="javascript:;" @click="$onlineconSultation()" class="sekBtn">咨询</a>
            </td>
            <td>
              <a href="javascript:;" @click="$pushTo(`/BeforeExam/curriculumInfo?id=${item.id}`)"
                class="buyBtn">购买课程</a>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
  <!-- Foor1 -->

  <!-- Foor2 -->
  <div class="idxFoor2">
    <div class="w1600">
      <div class="Hometit wow fadeInUp">
        <h3>考试用书</h3>
        <p>2024官方正版用书，指定教材+应试备考指导，助力考试通关</p>
      </div>
      <div class="clearfix">
        <div class="item wow fadeInUp" v-for="item in examBook" :key="item.id">
          <div class="imgBox" @click="$pushTo(`/BeforeExam/examBookInfo?id=${item.id}`)">
            <figure :style="'background-image:url(\'' + $bindImg(item.coverImage) + '\')'"></figure>
          </div>
          <div class="txtBox">
            <div class="titBox">
              <h5 class="dot">{{ item.title }}</h5>
              <div class="type">
                <span>{{ item.classification }}</span>
                <span>{{ item.classHour }}课时</span>
              </div>
            </div>
            <div class="teacList">
              <div class="iBox" v-for="(lecturer, lecturerIdx) in item.lecturerList" :key="lecturerIdx">
                <div class="userImg">
                  <img :src="$bindImg(lecturer.coverImage)" alt="" />
                </div>
                <p>{{ lecturer.title }}</p>
              </div>
            </div>
            <div class="directory">
              <h5>课程目录</h5>
              <div class="des">
                <p v-for="(catalog, cLogIdx) in item.catalogList.slice(0, 3)" :key="cLogIdx">
                  {{ catalog.title }}
                </p>
                <p v-if="item.catalogList.length > 3">. . . . . .</p>
              </div>
            </div>
            <div class="btnBox">
              <a @click="$pushTo(`/BeforeExam/viewingProcess`)" class="getBtn">领取视频</a>
              <a @click="$pushTo(`/BeforeExam/examBookInfo?id=${item.id}`)" class="goInfo">查看详细</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Foor2 -->

  <!-- Foor34 -->
  <div class="idxFoor34">
    <div class="w1600">
      <!-- <div class="idxFoor3">
        <div class="Hometit wow fadeInUp">
          <h3>业内课程</h3>
          <p>多家合作伙伴，为您提供完美方案</p>
        </div>

        <div class="swiper-container ky-swiper wow fadeInUp">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in ylkcList">
              <a href="javascript:;" @click="ylckUrl(item)">
                <div class="imgBox">
                  <figure :style="'background-image:url(\'' +
                    $bindImg(item.coverImage) +
                    '\')'
                    "></figure>
                </div>
                <div class="txtBox">
                  <time>{{ item.createTimeString }}</time>
                  <h5 class="dot2">{{ item.title }}</h5>

                  <p class="dot">{{ item.illustrate }}</p>
                  <span class="type ing">{{ item.label }}</span>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="swiper-pagination ky-dot"></div>
      </div> -->
      <div class="idxFoor4">
        <div class="Hometit wow fadeInUp">
          <h3>师资团队</h3>
          <p>深耕业内几十年，教育经验资深，对考试了如指掌</p>
        </div>
        <div class="sz-box wow fadeInUp">
          <div class="swiper-container sz-swiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="item in sztdList" :key="item.id">
                <div>
                  <div class="imgBox">
                    <img :src="$bindImg(item.coverImage)" alt="" />
                  </div>
                  <div class="txtBox">
                    <h5>{{ item.title }}</h5>
                    <p v-html="item.rank"></p>
                    <div class="cursL" v-html="item.illustrate"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Add Arrows -->
          <div class="swiper-button-prev sz-btn-prev"></div>
          <div class="swiper-button-next sz-btn-next"></div>
        </div>
        <a href="javascript:;" @click="$pushTo(`/BeforeExam/teachers`)" class="more">更多师资</a>
      </div>
    </div>
  </div>
  <!-- Foor34 -->

  <!-- Foor5 -->
  <div class="idxFoor5 wow fadeInUp">
    <div class="w1600 clearfix">
      <div class="item" v-for="item in dbbannerList" :key="item.id">
        <a @click="ylckUrl(item)">
          <img :src="$bindImg(item.coverImage)" alt="" />
          <div class="txtBox">
            <h5>{{ item.title }}</h5>
            <p>{{ item.illustrate }}</p>
            <span class="more"></span>
            <span class="en">{{ item.label }}</span>
          </div>
        </a>
      </div>
    </div>
  </div>
  <!-- <div id="sport_wrap" v-if="show" @mouseover="mouseOver" @mouseleave="mouseLeave">
    <div class="deleteImg" @click="showSport">
      <img src="@/assets/images/close.png" alt="">
    </div>
    <img :src="$bindImg(ad.coverImage)" alt="" class="wrap_img" @click="ylckUrl(ad)">
  </div> -->
  <div id="sport_wrap" v-if="show" @mouseover="mouseover" @mouseout="mouseout" class="box"
    :style="{ 'top': top + 'px', 'left': left + 'px' }">
    <div class="deleteImg">
      <img src="@/assets/images/close.png" alt="" @click="close(ad)">
    </div>
    <img :src="$bindImg(ad.coverImage)" @click="ylckUrl(ad)" alt="" class="wrap_img">
  </div>
  <bottom></bottom>
</template>


<script>
// import wow from "@/api/spark/wow.min";
import bottom from "@/components/BeforeExam/bottom";
import top from "@/components/BeforeExam/top";
import { GetPage, GetItemById } from "@/api/content";
import * as channelApi from "@/api/channel";
import { GetClassIntroductionPage } from "@/api/coursecategory";
import { WOW } from "wowjs";
import Swiper from "swiper";
import { get } from "jquery";

const course = require("@/api/course");
const exambook = require("@/api/exambook");

export default {
  metaInfo() {
    return {
      title: this.seoTitle,
      meta: [{                 // set keyWords
        name: 'keyWords',
        content: this.seoKeyWords
      },
      {                 // set Description
        name: 'Description',
        content: this.seoDescription
      }],
    };
  },
  components: {
    Swiper,
    bottom,
    top,
  },
  data() {
    return {
      seoTitle: '兰麦考前',
      seoKeyWords: '兰麦考前',
      seoDescription: '兰麦考前',
      adv: true,
      rdgzList: [], //热点关注
      ylkcList: [], //业内课程
      dbbannerList: [], //底部banner
      bannerList: [],
      saleBannerList: [],
      examBook: [],
      recommendedCourses: [], //推荐课程
      recommendedCourses1: [],
      Courses: [], //课程
      category: [], //课程班级
      sztdList: [], //师资团队
      ad: {},
      show: true, // 是否展现飘窗
      stepX: 1, // 水平方向的步长
      stepY: 1, // 垂直方向的步长
      timer: null, // 定时器
      maxTop: 0, // 最大的 top 值
      maxLeft: 0, // 最大的 left 值
      top: 0,
      left: 0,
    };
  },
  created() {
    const currentHost = window.location.host; // 获取当前访问页面的域名
    // console.log('currentHost:'+currentHost);
    if (currentHost == 'official.lanmaiedu.com' || currentHost == 'www.lanmaiedu.com') {
      this.$pushTo("/Web/index");
    }
    if (currentHost == 'training.lanmaiedu.com') {
      this.$pushTo("/IndustryTraining/index");
    }
    this.loadBannerList();
    this.loadExamBook();
    this.loadRecommendedCourses();
    this.loadRecommendedCourses1();
    this.loadCourses();

  },
  beforeUnmount() {
    clearInterval(this.timer)
  },
  mounted() {
    let that = this;
    that.$nextTick(() => {
      new WOW().init();
      that.init();

      that.initSeoObj();
    });
  },
  methods: {
    initSeoObj() {
      let _this = this;
      channelApi.GetItemById({
        id: 14,//ID 对应后台内容管理的栏目ID
      }).then((res) => {
        console.log('channelApi.GetItemById', res);
        _this.seoTitle = res.body.metaTitle;
        _this.seoKeyWords = res.body.metaKeywords;
        _this.seoDescription = res.body.metaDescription;
      }).catch((err) => {
        console.log('channelApi.GetItemById', err);
      }); // 设置页面SEO信息
    },
    init() {
      // 设置最大的top和left值：根元素可视区域宽高 - 飘窗的宽高 - 边距
      this.maxTop = document.documentElement.clientHeight - 150 - 20
      this.maxLeft = document.documentElement.clientWidth - 200 - 20

      // 设置 top 和 left 的初始值
      this.top = 0
      this.left = 0

      // 创建定时器前清除定时器，避免类似在 onresize 中调用 init() 时，产生多个定时器
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.move()
      }, 20)

      this.onresize()
    },
    // 移动函数
    move() {
      if (this.top >= this.maxTop || this.top < 0) {
        this.stepY = -this.stepY
      }
      if (this.left >= this.maxLeft || this.left < 0) {
        this.stepX = -this.stepX
      }

      this.top += this.stepY
      this.left += this.stepX
    },
    // 鼠标悬浮在飘窗时停止移动
    mouseover() {
      clearInterval(this.timer)
    },
    // 鼠标离开飘窗时恢复移动
    mouseout() {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.move()
      }, 20)
    },
    // 关闭飘窗
    close() {
      clearInterval(this.timer)
      this.show = false
    },
    // 窗口大小调整时重置飘窗规则
    onresize() {
      const that = this
      window.onresize = function () {
        that.init()
      }
    },
    jump(id) {
      var that = this
      that.$pushTo("/BeforeExam/curriculum?category1=" + id);
    },
    bindImg(img) {
      let that = this
      if (img.indexOf('http') > -1) {
        return img;
      }
      return that.$uploadfiles() + img;
    },
    //业内课程跳转
    ylckUrl(item) {
      if (item.linkUrl != null && item.linkUrl != "") {
        this.$pushTo(item.linkUrl);
      }
    },
    gotosztd(id) {
      console.log(id);
      this.$pushTo("/BeforeExam/teachersDeta?id=" + id);
    },

    //首页banner图
    loadBannerList() {
      let that = this;
      GetPage({
        pageIndex: 1,
        pageSize: 20,
        filter: JSON.stringify({ columnId: 1, enable: true }),

      }).then((res) => {
        that.bannerList = res.body.items;
        console.log("bannerList", that.bannerList);
        that.$nextTick(() => {
          new Swiper("#banner", {
            slidesPerView: 1,
            observer: true,
            observeParents: true,
            pagination: {
              el: "#banner .swiper-pagination",
            },
            navigation: {
              nextEl: "#banner .swiper-button-next",
              prevEl: "#banner .swiper-button-prev",
            },
            paginationClickable: true,
            autoplay: true,
            loop: true,
          });
        });
      }).catch((err) => {
        console.log('loadBannerList err', err);
      });

      //促销广告
      GetPage({
        pageIndex: 1,
        pageSize: 3,
        filter: JSON.stringify({ columnId: 4, enable: true }),
        sign: that.$sign(),
      }).then((res) => {
        that.saleBannerList = res.body.items;
        console.log("saleBannerList", that.saleBannerList);
      }).catch((err) => {
        console.log('促销广告 err', err);
      });

      //热点关注
      GetPage({
        pageIndex: 1,
        pageSize: 8,
        filter: JSON.stringify({ columnId: 13, show: true }),
      }).then((res) => {
        that.rdgzList = res.body.items;
        console.log("rdgzList", that.rdgzList);
      }).catch((err) => {
        console.log('热点关注 err', err);
      });

      //业内课程
      GetPage({
        pageIndex: 1,
        pageSize: 99,
        filter: JSON.stringify({ columnId: 19 }),
      }).then((res) => {
        that.ylkcList = res.body.items;
        // console.log("ylkcList", that.ylkcList);

        that.$nextTick(() => {
          new Swiper(".ky-swiper", {
            slidesPerView: 1,
            pagination: {
              el: ".ky-dot",
            },
            paginationClickable: true,
            autoplay: 5000,
            observer: true,
            observeParents: true,
            breakpoints: {
              768: {
                //当屏幕宽度大于等于768
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1280: {
                //当屏幕宽度大于等于1280
                slidesPerView: 3,
                spaceBetween: 30,
              },
            },
          });
        });
      }).catch((err) => {
        console.log('业内课程 err', err);
      });

      //底部banenr
      GetPage({
        pageIndex: 1,
        pageSize: 4,
        filter: JSON.stringify({ columnId: 20 }),
      }).then((res) => {
        that.dbbannerList = res.body.items;
        //console.log("dbbannerList", that.dbbannerList);
      }).catch((err) => {
        console.log('底部banenr err', err);
      });

      //课程班级
      GetClassIntroductionPage({
        pageIndex: 1,
        pageSize: 4,
        filter: JSON.stringify({ columnId: 10, enable: true }),
      }).then((res) => {
        that.category = res.body.items;
      }).catch((err) => {
        console.log('课程班级 err', err);
      });

      //师资团队
      GetPage({
        pageIndex: 1,
        pageSize: 20,
        filter: JSON.stringify({
          columnId: 2,
          show: true,//首页推荐显示
          enable: true//状态是否启用
        }),
        siteId: 1,
      }).then((res) => {
        that.sztdList = res.body.items;
        //console.log("sztdList", that.sztdList);
        that.$nextTick(() => {
          let szswiper = new Swiper(".sz-swiper", {
            slidesPerView: 1,
            centeredSlides: true,
            autoplay: 3000,
            loop: true,
            observer: true,
            navigation: {
              nextEl: ".sz-btn-next",
              prevEl: ".sz-btn-prev",
            },
            breakpoints: {
              768: {
                //当屏幕宽度大于等于768
                slidesPerView: 1,
                spaceBetween: 20,
              },
              1280: {
                //当屏幕宽度大于等于1280
                slidesPerView: 5,
                spaceBetween: 30,
              },
            },
            on: {
              // 使用了loop属性后无法正常在页面上添加点击事件
              click: (event) => {
                // 获取点击的幻灯片
                var clickedSlide = event.target.closest(".swiper-slide");
                console.log(clickedSlide);
                if (clickedSlide) {
                  // 获取当前点击的幻灯片的下标
                  var clickedIndex = clickedSlide.getAttribute(
                    "data-swiper-slide-index"
                  );
                  var id = this.sztdList[clickedIndex].id;
                  that.gotosztd(id);
                }
              },
            },
          });
        });
      }).catch((err) => {
        console.log('师资团队 err', err);
      });

      GetItemById({
        id: 654,
        isRelated: false,
        columnId: 51
      }).then((res) => {
        that.ad = res.body;
        that.show = that.ad.enable;
      }).catch((err) => {
        console.log("err", err);
      });
    },
    //考试用书
    loadExamBook() {
      let that = this;
      exambook.GetPage({
        pageIndex: 1,
        pageSize: 4,
        filter: JSON.stringify({ enable: true }),
      }).then((res) => {
        that.examBook = res.body.items;
        //console.log("examBook", this.examBook);
      }).catch((err) => {

      });
    },
    //banner下方推荐课程
    loadRecommendedCourses1() {
      let that = this;
      course.GetPage({
        pageIndex: 1,
        pageSize: 3,
        filter: JSON.stringify({ recommend: true, enable: true }),
      }).then((res) => {
        that.recommendedCourses1 = res.body.items;
      }).catch((err) => {

      });
    },
    //推荐课程
    loadRecommendedCourses() {
      let that = this;
      course.GetPage({
        pageIndex: 1,
        pageSize: 5,
        filter: JSON.stringify({ recommend: true, enable: true }),
      }).then((res) => {
        that.recommendedCourses = res.body.items;
      }).catch((err) => {

      });
    },
    //课程
    loadCourses() {
      let that = this;
      course.GetPage({
        pageIndex: 1,
        pageSize: 20,
        filter: JSON.stringify({ enable: true }),
      }).then((res) => {
        that.Courses = res.body.items;
      }).catch((err) => {

      });
    },


    // swiper
    getswiper() { },
  },
  computed: {
    windowWidth() {
      // Calculate window width
      return this.$el.offsetWidth;
    },
    windowHeight() {
      // Calculate window height
      return this.$el.offsetHeight;
    },
  },
};
</script>
